<template>
    <el-input v-model="lngLat" placeholder="经度,纬度" v-bind="$attrs" @change="handleChange">
        <template #append>
            <slot name="append"></slot>
        </template>
    </el-input>
</template>

<script>
export default {
    name: 'LngLatInput',
    props: {
        longitude: {
            type: [String, Number],
            default: '',
        },
        latitude: {
            type: [String, Number],
            default: '',
        },
    },
    data() {
        return {
            lngLat: '',
        };
    },
    watch: {
        longitude: {
            handler() {
                this.formatValue();
            },
            immediate: true,
        },
        latitude: {
            handler() {
                this.formatValue();
            },
            immediate: true,
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.formatValue();
        });
    },
    methods: {
        formatValue() {
            let longitude = this.longitude;
            let latitude = this.latitude;
            let value = '';
            if (longitude) {
                value = `${longitude}`;
                if (latitude) {
                    value = `${value},${latitude}`;
                }
            }
            this.lngLat = value;
        },
        handleChange(event) {
            let longitude = '';
            let latitude = '';
            let value = event;
            if (value) {
                value = value.split(',');
                longitude = value[0] || '';
                latitude = value[1] || '';
            }
            this.$emit('update:longitude', longitude);
            this.$emit('update:latitude', latitude);
        },
    },
};
</script>

<style lang="scss" scoped></style>
